import { useMemo } from 'react';

import InsightsApiExport from 'components/insights/layout/InsightsApiExport';
import { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import {
  getInboundReferralAnalyticsFilters,
  useInboundReferralsInsightsStore,
} from 'stores/inboundReferralsInsightsStore';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: InsightsQueryParams;
  extraFilters?: Record<string, unknown> | null;
};

export default function InboundReferralApiExport({ extraFilters = null, ...props }: Props) {
  const baseFilters = useInboundReferralsInsightsStore((state) => getInboundReferralAnalyticsFilters(state));
  const analyticsFilters = useMemo(
    () => (baseFilters ? { ...baseFilters, ...(extraFilters ?? {}) } : null),
    [baseFilters, extraFilters]
  );

  return <InsightsApiExport {...props} analyticsFilters={analyticsFilters} />;
}
